const resize2fit = (elements) => {
  elements.forEach((el) => {
    if (!el || !el.parentElement || !el.children || el.children.length === 0) return;

    el.style.setProperty("--font-size", "1.5em");

    const { width: max_width, height: max_height } = el.getBoundingClientRect();
    const child = el.children[0];

    if (!child || typeof child.getBoundingClientRect !== "function") return;

    const { width, height } = child.getBoundingClientRect();

    if (width === 0 || height === 0) return;

    const newSize = Math.min(max_width / width, max_height / height);
    el.style.setProperty("--font-size", newSize + "em");
  });
};

export default resize2fit;
